import React, { useState } from 'react';
import './ReviewPopup.css';
import api from '../../api'; // centralized Axios instance

function ReviewPopup({ productId, buyer, buyerUsername, onClose, onSubmitSuccess }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // local toast (success | error) scoped to this popup
  const [toast, setToast] = useState({ visible: false, message: '', type: '' });
  const showToast = (message, type = 'success', { onDone, duration = 2200 } = {}) => {
    setToast({ visible: true, message, type });
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(() => {
      setToast({ visible: false, message: '', type: '' });
      if (typeof onDone === 'function') onDone();
    }, duration);
  };

  const submitReview = async () => {
    try {
      setSubmitting(true);

      await api.post('/reviews', {
        productId,
        buyer: buyer || buyerUsername, // support both prop names
        rating,
        comment,
      });

      // success toast, then close (and let parent know if it wants to)
      showToast(' Review submitted!', 'success', {
        onDone: () => {
          if (typeof onSubmitSuccess === 'function') onSubmitSuccess();
          if (typeof onClose === 'function') onClose();
        },
      });
    } catch (err) {
      console.error('❌ Error submitting review:', err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        '❌ Error submitting review.';
      showToast(msg, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <h3>Leave a Review</h3>
        <p>How was your experience with this product?</p>

        <div style={{ marginBottom: '8px' }}>
          <label>Rating:</label>
          <select
            value={rating}
            onChange={(e) => setRating(parseInt(e.target.value))}
            disabled={submitting}
          >
            {[5, 4, 3, 2, 1].map((r) => (
              <option key={r} value={r}>{r} ★</option>
            ))}
          </select>
        </div>

        <textarea
          placeholder="Write your review here..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
          style={{ width: '100%' }}
          disabled={submitting}
        />

        <div className="popup-actions">
          <button className="review-cancel-btn" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button className="review-submit-btn" onClick={submitReview} disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </div>

      {/* popup-scoped toast */}
      {toast.visible && (
        <div className={`review-toast ${toast.type}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
}

export default ReviewPopup;
